import React, { useState, useEffect, useContext } from 'react';
import { Box, Typography, Button, IconButton, Card, Avatar, useMediaQuery } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckIcon from '@mui/icons-material/Check';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import useOrders from '../../../lib/hooks/useOrders';
import { OrdersContext } from '../../../lib/contexts/OrdersContext';
import useMealOptions from '../../../lib/hooks/useMealOptions';

const MealOrderOptionsMenu = ({ order, onClose, onAddMeal }) => {
  const [selectedMeals, setSelectedMeals] = useState([]);
  const [mealOptions, setMealOptions] = useState(null);
  // const { state: { mealOptionsData } } = useContext(OrdersContext);
  const { data } = useOrders('');
  const {
    state: { mealOptionsData },
  } = useContext(OrdersContext);
  // const { data: mealOptionsData } = useMealOptions(order?.benefit_id);
  // console.log('here is the order in MealOrderOptionsMenu: ', order);
  const mealGenreGroups = data?.mealGenreGroups || {};
  const isMobileView = useMediaQuery('(max-width: 600px)');
  const handleSelectMeal = (meal) => {
    if (selectedMeals.includes(meal.box_id)) {
      setSelectedMeals(selectedMeals.filter((id) => id !== meal.box_id));
    } else {
      setSelectedMeals([...selectedMeals, meal.box_id]);
    }
    // console.log('here is the meal in handleSelectMeal: ', meal);
    // console.log('here is the mealOptions in handleSelectMeal: ', mealOptions);
    // console.log('here is the meal.box_id in handleSelectMeal: ', meal.box_id);
  };

  useEffect(() => {
    setMealOptions(mealOptionsData?.boxes);
  }, [mealOptionsData]);

  // useEffect(() => {
  //     console.log('here are the selectedMeals in MealOrderOptionsMenu in useEffect: ', selectedMeals);
  // }, [selectedMeals]);

  const handleAddToOrder = () => {
    const mealsToAdd = selectedMeals
      .map((mealId) => {
        return mealOptions.find((m) => m.box_id === mealId);
      })
      .filter((meal) => meal !== undefined);

    // console.log('here is the mealsToAdd in handleAddToOrder: ', mealsToAdd);

    const adjustedMealsToAdd = [];

    for (const meal of mealsToAdd) {
      const newMeal = {
        box_description: meal.description,
        box_id: meal.box_id,
        box_image: meal.media[0],
        box_name: meal.name,
        box_type: meal.type,
        order_id: order.id,
        quantity: 1,
        store_item_id: meal.store_item_id,
      };
      adjustedMealsToAdd.push(newMeal);
    }

    // console.log('here is the adjustedMealsToAdd in handleAddToOrder: ', adjustedMealsToAdd);

    onAddMeal(adjustedMealsToAdd);
    onClose();
  };

  // Get the appropriate meal options based on order's mealGenre
  const getMealOptions = () => {
    return mealGenreGroups[order?.mealGenre] || [];
  };

  return (
    <Box
      id="add-item-container"
      sx={{
        display: 'flex',
        width: isMobileView ? '400px' : '440px',
        height: '968px',
        padding: '24px 32px',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        flexShrink: 0,
        borderLeft: '1px solid var(--color4, #EBE8F3)',
        background: 'var(--color1, #FDFDFD)',
        boxShadow:
          '0px 4px 5px 0px rgba(0, 0, 0, 0.02), 0px 1px 10px 0px rgba(0, 0, 0, 0.02), 0px 2px 4px -1px rgba(17, 17, 17, 0.03)',
      }}
    >
      <Box
        id="meal-list-container"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '16px',
          alignSelf: 'stretch',
        }}
      >
        <Box
          id="header"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 'var(--2-5, 10px)',
          }}
        >
          <Box
            id="header-title"
            sx={{
              display: 'flex',
              width: '376px',
              alignItems: 'flex-start',
              gap: '10px',
            }}
          >
            <Box
              id="back-button-container"
              sx={{
                display: 'flex',
                width: '24px',
                height: '38px',
                alignItems: 'center',
                gap: '10px',
                flexShrink: 0,
              }}
            >
              <ArrowBackIcon
                onClick={onClose}
                style={{
                  height: '24px',
                  flex: '1 0 0',
                }}
              />
            </Box>
            <Box
              id="title-label"
              sx={{
                display: 'flex',
                width: '309px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '4px',
                flexShrink: 0,
              }}
            >
              <Box
                id="title-wrapper"
                sx={{
                  display: 'flex',
                  padding: '4px 0px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '10px',
                  alignSelf: 'stretch',
                }}
              >
                <Typography
                  sx={{
                    color: 'var(--color12, #1C124D)',
                    textAlign: 'center',
                    fontFamily: 'Montserrat',
                    fontSize: '24px',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    lineHeight: '125%', // 30px
                  }}
                >
                  Add Item to Order
                </Typography>
              </Box>
              <Box
                id="label-wrapper"
                sx={{
                  display: 'flex',
                  width: '376px',
                  padding: '4px 0px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <Typography
                  sx={{
                    color: 'var(--color12, #1C124D)',
                    textAlign: 'center',
                    leadingTrim: 'both',
                    textEdge: 'cap',
                    fontFamily: 'Montserrat',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: 'normal',
                    flex: '1 0 0',
                  }}
                >
                  Select an Item Below.
                </Typography>
              </Box>
            </Box>
          </Box>
          {/* <Box
                        id='header-note'
                        sx={{
                            display: 'flex',
                            width: '376px',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            gap: 'var(--3-5, 16px)',
                        }}
                    >
                        <Button
                            sx={{
                                display: 'flex',
                                height: 'var(--4, 44px)',
                                padding: 'var(--0, 0px) var(--4, 18px)',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: 'var(--4, 18px)',
                                alignSelf: 'stretch',
                                borderRadius: 'var(--4, 9px)',
                            }}
                        >
                            <Typography
                                sx={{
                                    color: 'var(--color12, #1C124D)',
                                    textAlign: 'center',
                                    leadingTrim: 'both',
                                    textEdge: 'cap',
                                    fontFamily: 'Montserrat',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    lineHeight: 'normal',
                                }}
                            >
                                Why am I seeing these meals?
                            </Typography>
                            <Info
                                style={{
                                    width: 'var(--1-5, 24px)',
                                    height: '24px',
                                }}
                            />
                        </Button>
                    </Box> */}
        </Box>
        <Box
          id="body-container"
          sx={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: '16px',
            alignSelf: 'stretch',
          }}
        >
          <Box
            id="body"
            sx={{
              display: 'flex',
              height: '640px',
              flexDirection: 'column',
              overflowY: 'auto',
              gap: '16px',
              // border: '1px solid black',
            }}
          >
            {mealOptions?.map((meal) => (
              <Box
                id="meal-item"
                sx={{
                  display: 'flex',
                  padding: '16px 20px 16px 16px',
                  alignItems: 'center',
                  gap: '16px',
                  alignSelf: 'stretch',
                  borderRadius: '8px',
                  border: '1px solid var(--color6, #D6D2E7)',
                }}
              >
                <Box
                  id="meal-image"
                  sx={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '64px',
                    // background: `url(https://loremflickr.com/320/240/food?random=${1}&lock=${1}) lightgray 50% / cover no-repeat`,
                    background: `url(${meal.media[0]}) lightgray 50% / cover no-repeat`,
                    boxShadow:
                      '1px 2px 3px 0px rgba(0, 0, 0, 0.17), 0px 1px 10px 0px rgba(0, 0, 0, 0.02), 0px 2px 4px -1px rgba(17, 17, 17, 0.03)',
                  }}
                />
                <Box
                  id="meal-item-label-container"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: '12px',
                    flex: '1 0 0',
                  }}
                >
                  <Box
                    id="meal-item-label"
                    sx={{
                      display: 'flex',
                      paddingRight: '4px',
                      alignItems: 'flex-start',
                      gap: '8px',
                      alignSelf: 'stretch',
                    }}
                  >
                    <Typography
                      sx={{
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        flex: '1 0 0',
                        overflow: 'hidden',
                        color: 'var(--color12, #1C124D)',
                        leadingTrim: 'both',
                        textEdge: 'cap',
                        textOverflow: 'ellipsis',
                        fontFamily: 'Montserrat',
                        fontSize: '18px',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        lineHeight: 'normal',
                      }}
                    >
                      {meal.name}
                    </Typography>
                    {/* <Box
                                    id='meal-item-quantity-container'
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        alignSelf: 'stretch',
                                    }}
                                    >
                                        <Typography
                                            sx={{
                                                color: 'var(--color12, #1C124D)',
                                                leadingTrim: 'both',
                                                textEdge: 'cap',
                                                fontFamily: 'Montserrat',
                                                fontSize: '16px',
                                                fontStyle: 'normal',
                                                fontWeight: 400,
                                                lineHeight: 'normal',
                                            }}
                                        >
                                            x2
                                        </Typography>
                                    </Box> */}
                  </Box>
                  {selectedMeals.includes(meal.box_id) ? (
                    <Button
                      onClick={() => handleSelectMeal(meal)}
                      sx={{
                        display: 'flex',
                        height: 'var(--3, 36px)',
                        padding: 'var(--0, 0px) var(--3, 13px)',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 'var(--3, 13px)',
                        alignSelf: 'stretch',
                        borderRadius: 'var(--3, 7px)',
                        border: 'var(--1, 2px) solid var(--Tangelo-Matcha-matcha6, #A2E2D4)',
                        background: 'var(--Tangelo-Matcha-matcha6, #A2E2D4)',
                      }}
                    >
                      <CheckIcon
                        sx={{
                          width: 'var(--1, 20px)',
                          height: 'var(--1, 20px)',
                        }}
                      />
                      <Typography
                        sx={{
                          color: 'var(--color12, #1C124D)',
                          textAlign: 'center',
                          leadingTrim: 'both',
                          textEdge: 'cap',
                          fontFamily: 'Montserrat',
                          fontSize: '14px',
                          fontStyle: 'normal',
                          fontWeight: 700,
                          lineHeight: 'normal',
                        }}
                      >
                        Selected
                      </Typography>
                    </Button>
                  ) : (
                    <Button
                      onClick={() => handleSelectMeal(meal)}
                      sx={{
                        display: 'flex',
                        height: 'var(--3, 36px)',
                        padding: 'var(--0, 0px) var(--3, 13px)',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 'var(--3, 13px)',
                        alignSelf: 'stretch',
                        borderRadius: 'var(--3, 7px)',
                        border: 'var(--1, 2px) solid var(--color12, #1C124D)',
                      }}
                    >
                      <Typography
                        sx={{
                          color: 'var(--color12, #1C124D)',
                          textAlign: 'center',
                          leadingTrim: 'both',
                          textEdge: 'cap',
                          fontFamily: 'Montserrat',
                          fontSize: '14px',
                          fontStyle: 'normal',
                          fontWeight: 700,
                          lineHeight: 'normal',
                        }}
                      >
                        Select Item
                      </Typography>
                    </Button>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
      <Box
        id="add-item-button-box"
        sx={{
          display: 'flex',
          width: '440px',
          padding: '8px 32px 40px 32px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '16px',
          position: 'absolute',
          bottom: '-18px',
          background: 'var(--color1, #FDFDFD)',
        }}
      >
        <Button
          disabled={selectedMeals.length === 0}
          onClick={handleAddToOrder}
          sx={{
            display: 'flex',
            height: 'var(--4, 44px)',
            padding: 'var(--0, 0px) var(--4, 18px)',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 'var(--4, 18px)',
            alignSelf: 'stretch',
            borderRadius: 'var(--4, 9px)',
            border: '1px solid var(--color12, #1C124D)',
            background: 'var(--color12, #1C124D)',
          }}
        >
          <Typography
            sx={{
              color: '#FDFDFD',
              textAlign: 'center',
              leadingTrim: 'both',
              textEdge: 'cap',
              fontFamily: 'Montserrat',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: 'normal',
            }}
          >
            Add to Order
          </Typography>
        </Button>
      </Box>
    </Box>
  );

  // return (
  //     <Box sx={{
  //         width: '100%',
  //         maxWidth: '600px',
  //         margin: 'auto',
  //         p: 2
  //     }}>
  //         {/* Header */}
  //         <Box sx={{
  //             display: 'flex',
  //             alignItems: 'center',
  //             mb: 3
  //         }}>
  //             <IconButton onClick={onClose} sx={{ mr: 2 }}>
  //                 <ArrowBackIcon />
  //             </IconButton>
  //             <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
  //                 <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
  //                     Add Item to Order
  //                 </Typography>
  //                 <Typography variant="body2" color="text.secondary">
  //                     Select an item below.
  //                 </Typography>
  //                 <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
  //                     <Typography variant="body2" color="text.secondary">
  //                         Why am I seeing these meals?
  //                     </Typography>
  //                     <InfoOutlinedIcon color="action" />
  //                 </div>
  //             </Box>
  //         </Box>

  //         {/* "Why am I seeing these meals?" section */}
  //         {/* <Box sx={{
  //             display: 'flex',
  //             alignItems: 'center',
  //             // mb: 3
  //         }}>
  //             <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mr: 1 }}>
  //                 Why am I seeing these meals?
  //             </Typography>
  //             <InfoOutlinedIcon color="action" />
  //         </Box> */}

  //         {/* Meal Options List */}
  //         <Box
  //             id="meal-options-list"
  //             sx={{
  //                 maxHeight: '450px', // Fixed height for the scrollable area
  //                 overflowY: 'auto', // Enable vertical scrolling
  //                 mb: 3, // Margin bottom to separate from the button
  //             }}
  //         >
  // {getMealOptions().map((meal) => (
  //     <Card
  //         key={meal.id}
  //         sx={{
  //             p: '16px 20px 16px 16px',
  //             display: 'flex',
  //             mb: '16px',
  //             flexDirection: 'row',
  //             width: '100%',
  //             height: '112px',
  //             gap: '16px',
  //             borderRadius: '8px 0px 0px 0px',
  //             border: '1px solid #D1D5DB',
  //             // borderWidth: '1px 0px 0px 0px',
  //             // boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
  //             '&:hover': {
  //                 borderColor: '#9CA3AF'
  //             }
  //         }}
  //     >
  //         <Avatar
  //             src={`https://loremflickr.com/320/240/food?random=${meal.id}`}
  //             alt={meal.name}
  //             sx={{
  //                 width: 64,
  //                 height: 64,
  //                 borderRadius: '8px'
  //             }}
  //             variant="rounded"
  //         />
  //         <Box sx={{
  //             display: 'flex',
  //             flexDirection: 'column',
  //             ml: 2,
  //             flex: 1
  //         }}>
  //             <Typography
  //                 variant="subtitle1"
  //                 sx={{
  //                     fontWeight: 'bold',
  //                     color: '#1F2937',
  //                     mb: 1,
  //                     fontSize: isMobile ? '0.875rem' : '1rem',
  //                 }}
  //             >
  //                 {meal.name}
  //             </Typography>
  //             <Button
  //                 variant={selectedMeals.includes(meal.id) ? "contained" : "outlined"}
  //                 onClick={() => handleSelectMeal(meal)}
  //                 sx={{
  //                     color: selectedMeals.includes(meal.id) ? '#FFFFFF' : '#1F2937',
  //                     borderColor: '#1F2937',
  //                     backgroundColor: selectedMeals.includes(meal.id) ? '#1F2937' : 'transparent',
  //                     textTransform: 'none',
  //                     height: '36px',
  //                     '&:hover': {
  //                         borderColor: '#1F2937',
  //                         backgroundColor: selectedMeals.includes(meal.id) ? '#374151' : '#F9FAFB'
  //                     }
  //                 }}
  //             >
  //                 {selectedMeals.includes(meal.id) ? "Selected" : "Select Item"}
  //             </Button>
  //         </Box>
  //     </Card>
  // ))}
  //         </Box>

  //         {/* Add to Order Button */}
  //         <Button
  //             variant="contained"
  //             fullWidth
  //             disabled={selectedMeals.length === 0}
  //             onClick={handleAddToOrder}
  //             sx={{
  //                 mt: 3,
  //                 mb: 2,
  //                 py: 1.5,
  //                 backgroundColor: '#1F2937',
  //                 textTransform: 'none',
  //                 fontWeight: 'bold',
  //                 '&:hover': {
  //                     backgroundColor: '#374151'
  //                 }
  //             }}
  //         >
  //             Add to Order
  //         </Button>
  //     </Box>
  // );
};

export default MealOrderOptionsMenu;
